<template @scroll.native="getScroll">
  <div class="qyxxbgDialogFather">
    <!-- 单位信息 -->
    <qyxxbg-dialog-1
      id="jbxx"
      ref="child1"
      :dw-bgjl-dto="dwBgjlDto"
      @show="getdwBgjlDto"
    />
    <!-- 法人/经营者信息 -->
    <qyxxbg-dialog-2
      id="faren"
      ref="child2"
      :fr-bgjl-dto="frBgjlDto"
      @show="getfrBgjlDto"
    />
    <!-- 化学品信息 -->
    <qyxxbg-dialog-3
      id="hxp"
      ref="child3"
      :hxp-bgjl-dtos="hxpBgjlDtos"
      :dwbgjl-id="dwbgjlId"
      @show="gethxpBgjlDtos"
      @validate="getValidate"
    />
    <div :style="navigationStyle()" class="navigation">
      <img
        v-for="(item, index) in navigationImg"
        :key="index"
        v-preventReClick
        :style="navigationItemStyle(item.flag, item.ref)"
        :src="item.flag ? item.img1 : item.img2"
        @click="change(item)"
      >
    </div>
  </div>
</template>
<script>
import { getNewBgxx, editDraft, getBgjlZzjls } from '@/assets/js/qyxxbg.js'
import QyxxbgDialog1 from './qyxxbgDialog1.vue'
import QyxxbgDialog2 from './qyxxbgDialog2.vue'
import QyxxbgDialog3 from './qyxxbgDialog3.vue'
export default {
  components: { QyxxbgDialog1, QyxxbgDialog2, QyxxbgDialog3 },
  props: { EditId: String },
  data() {
    return {
      /* 三张表单数据 */
      dwBgjlDtoOld: {}, // 单位变更备份
      frBgjlDtoOld: {}, // 法人/经营者变更备份
      hxpBgjlDtosOld: [], // 化学品备份
      /* 附件模块数据 */
      dwbgjlId: '', // 单位变更记录id  附件模块调用接口会用到
      todoDelZjlx: '', // 子组件传来的需要删除的证件类型列表
      dwFjlxZl: '2,3,6,12,13,16,17,22,23', // 总证件类型
      isUpdate: false, // 子组件3附件信息修改 会将此属性赋值为true 用于最后提交时判断附件是否修改
      /* 导航栏数据 */
      heightWindow: null,
      widthWindow: null,
      dwBgjlDto: {
        // 单位变更
        id: '', // 主键
        dwmc: '', // 单位名称
        shtyxydm: '', // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: '', // 单位类型
        dwzs: '', // 单位住所
        frmc: '', // 法人/经营者名称
        zczb: '', // 注册资本
        clrq: '', // 成立日期
        yyqxKs: '', // 营业期限开始
        yyqxJs: '', // 营业期限结束
        jyfw: '', // 经营范围
        dwzj: '', // 单位座机
        dwsj: '', // 单位手机
        sjjyd: '', // 实际经营地
        cyrysl: '', // 从业人员数量
        st: '', // 省厅
        sj: '', // 市局
        qxj: '', // 区县级
        pcs: '', // 派出所
        by2: '', // 货币
        yyzzUrl: '', // 营业执照路径
        YyqxDate: [] // 营业执照路径
      },
      frBgjlDto: {
        // 法人/经营者变更
        id: '',
        dwid: '',
        xm: '',
        zw: '',
        jg: '',
        sjzz: '',
        bgdh: '',
        sjhm: '',
        zjlx: '1',
        qtzj: '',
        zjhm: '',
        xb: '',
        mz: '',
        sr: '',
        yxqxKs: '',
        yxqxJs: '',
        fzjg: '',
        zjzpZm: '2021/11/12/a674bdfc-3b83-4c0b-8a0c-f05ffe74042f.jpg',
        zjzpFm: '2021/11/12/3d71d32f-e44a-42f9-b642-061b0f385d78.jpg',
        yxqxDate: ''
      },
      hxpBgjlDtos: [], // 化学品
      navigationImg: [
        {
          ref: 1,
          img1: require('@/assets/img/jbxxbg1.png'),
          img2: require('@/assets/img/jbxxbg2.png'),
          flag: true
        },
        {
          ref: 2,
          img1: require('@/assets/img/frxxbg1.png'),
          img2: require('@/assets/img/frxxbg2.png'),
          flag: false
        },
        {
          ref: 3,
          img1: require('@/assets/img/zzzj1.png'),
          img2: require('@/assets/img/zzzj2.png'),
          flag: false
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {
    window.addEventListener('resize', this.GetWindowInfo)
    this.GetWindowInfo() // 页面创建时先调用一次
    window.addEventListener('scroll', this.getScroll, true)
  },
  mounted() {
    this.loadFormData() // 加载各个组件的数据
  },
  beforeDestroy() {},
  methods: {
    getValidate(callback) {
      // 子组件3提交时调用 校验3个子组件的表单并返回boolean
      var rs = this.$refs.child1.validate() && this.$refs.child2.validate()
      callback(rs)
    },
    // 父子双向通信
    gethxpBgjlDtos(val) {
      this.hxpBgjlDtos = val
    },
    getfrBgjlDto(val) {
      this.frBgjlDto = val
    },
    getdwBgjlDto(val) {
      this.dwBgjlDto = val
    },
    // 快捷导航
    navigationStyle() {
      return {
        top: '200px',
        right: this.widthWindow * 0.03 + 'px'
      }
    },
    navigationItemStyle(flag, ref) {
      if (ref == 3) {
        if (flag) {
          return {
            width: '207px',
            height: '56px',
            position: 'relative',
            left: '-10px'
          }
        }
        return {
          width: '207px',
          height: '56px'
        }
      } else {
        if (flag) {
          return {
            width: '171px',
            height: '56px',
            position: 'relative',
            left: '-10px'
          }
        }
        return {
          width: '171px',
          height: '56px'
        }
      }
    },
    getScroll(event) {
      const top = event.target.scrollTop
      if (top >= 0 && top < 1230) {
        this.navigationImg.forEach((element) => {
          element.flag = false
        })
        this.navigationImg[0].flag = true
      } else if (top >= 1230 && top <= 2120) {
        this.navigationImg.forEach((element) => {
          element.flag = false
        })
        this.navigationImg[1].flag = true
      } else {
        this.navigationImg.forEach((element) => {
          element.flag = false
        })
        this.navigationImg[2].flag = true
      }
    },
    change(item) {
      switch (item.ref) {
        case 1:
          document
            .querySelector('#jbxx')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
        case 2:
          document
            .querySelector('#faren')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
        case 3:
          document
            .querySelector('#hxp')
            .scrollIntoView({ block: 'start', behavior: 'smooth' })
          break
      }
      this.navigationImg.forEach((element) => {
        element.flag = false
      })
      item.flag = true
    },
    // 加载数据
    loadFormData() {
      if (this.EditId.length == 0) {
        // 新增
        getNewBgxx().then((e) => {
          // 通过接口值 分配三个组件的值
          this.setDataSource(e.data.data)
        })
      } else {
        // 编辑
        editDraft(this.EditId).then((e) => {
          // 通过接口值 分配三个组件的值
          this.setDataSource(e.data.data)
        })
      }
    },
    setDataSource(data) {
      // 获取已有资质证件
      getBgjlZzjls(data.dwbgjlId).then((e) => {
        this.$refs.child3.haveDwFjlxZl = e.data.data // 将获取的资质证件传给子组件3
      })
      this.dwBgjlDto = data.dwBgjlDto // 单位数据
      this.frBgjlDto = data.frBgjlDto // 法人数据
      this.hxpBgjlDtos = data.hxpBgjlDtos // 化学品数据
      this.dwbgjlId = data.dwbgjlId // 单位变更记录id  附件模块调用接口会用到

      // 保留备份
      this.dwBgjlDtoOld = Object.assign({}, data.dwBgjlDto)
      this.frBgjlDtoOld = Object.assign({}, data.frBgjlDto)
      this.hxpBgjlDtosOld = JSON.parse(JSON.stringify(data.hxpBgjlDtos))
    },
    GetWindowInfo() {
      this.widthWindow = window.innerWidth // 宽
      this.heightWindow = window.innerHeight // 高
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgDialogFather {
  /* width: 90%;
  margin: auto;
  max-width: 1200px; */
  position: relative;
  .navigation {
    position: fixed;
    z-index: 10;
    width: 150px;
  }
}
</style>
